import { DatasetService } from '~/support/services';

import { SET_DATASET } from './mutation-types';

export default {
  async bulkCreate(_, payload) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.bulkCreate(payload);

    return data;
  },

  async bulkDelete(_, payload) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.bulkDelete(payload);

    return data;
  },

  async bulkGenerateNewIds(_, payload) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.bulkGenerateNewIds(payload);

    return data;
  },

  async cloneDataset(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.cloneDataset(datasetId);
  },

  async createDataset(_, payload) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.createDataset(payload);

    return data;
  },

  async createSchedules(_, { datasetId, payload }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.createSchedules(datasetId, payload);
  },

  async deleteDataset(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    await service.deleteDataset(datasetId);
  },

  async deleteSchedules(_, { datasetId, type }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.deleteSchedules(datasetId, type);
  },

  async fetchDataset({ commit }, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.fetchOne(datasetId);

    commit(SET_DATASET, data);

    return data;
  },

  async fetchDatasets(_) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.fetchAll();

    return data;
  },

  async fetchDeploymentLogs(_, { datasetId, label, pageToken }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchDeploymentLogs(datasetId, {
      label,
      pageToken,
    });
  },

  async fetchFrames(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchFrames(datasetId);
  },

  async fetchFramesV2(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchFramesV2(datasetId);
  },

  async fetchHistory(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchHistory(datasetId);
  },

  async fetchInferredScheduleHeatmap(_, { datasetId, type, startDate, endDate }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchInferredScheduleHeatmap(datasetId, type, startDate, endDate);
  },

  async fetchProfileLogs(_, { datasetId, datastoreId, pageToken }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchProfileLogs(datasetId, {
      datastoreId,
      pageToken,
    });
  },

  async fetchSchedules(_, datasetId) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.fetchSchedules(datasetId);
  },

  async reRunPipeline(_, { datasetId, deliveryId }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);
    const data = await service.reRunPipeline(datasetId, deliveryId);

    return data;
  },

  async updateDataset({ dispatch }, { datasetId, payload }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    await service.updateDataset(datasetId, payload);

    return await dispatch('fetchDataset', datasetId);
  },

  async updateSchedules(_, { datasetId, payload }) {
    const service = new DatasetService(useRuntimeConfig().public.datasetsBaseUrl);

    return await service.updateSchedules(datasetId, payload);
  },
};
